/**
 * Main styling page for Feed Card Component
 *
 * @author Creator-Solutions - Owen Burns
 */
import { NavLink as BaseNavLink } from "react-router-dom";

import styled from "styled-components";

const FeedCardContainer = styled.div`
  width: 40vw;
  height: 75vh;
  &:hover {
    background-color: #212529;
  }

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100vw;
    height: auto;
    margin-top: 15px;
    margin-bottom: 10px;
  }
`;

const TopContainer = styled.div`
  width: 40vw;
  height: 5vh;
  display: flex;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100vw;
  }
`;

const PinnedContainer = styled.div`
  width: 10vw;
  height: 4vh;
  display: flex;
  flex-direction: row;
  margin-left: 15px;
  background-color: #212529;
  justify-content: center;
  border-radius: 15px;
  align-self: center;

  img {
    align-self: center;
  }
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 50vw;
  }
`;

const PinnedContent = styled.p`
  color: #c0c0c0;
  font-size: 14px;
  font-weight: 600;
  margin-left: 15px;
  align-self: center;
`;

const TitleBar = styled.div`
  width: 40vw;
  height: 10vh;
  display: flex;
  flex-direction: row;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100vw;
    height: 12vh;
  }
`;

const ProfileImage = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  align-self: center;
  margin: 0px 0px 0px 10px;
`;

const CardTitleInfo = styled.div`
  width: 25vw;
  height: 90%;
  align-self: center;
  margin-left: 15px;
  display: flex;
  flex-direction: column;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100vw;
    margin-left: 10px;
  }
`;

const CardAuthorDetails = styled.div`
  width: 15vw;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 60vw;
  }
`;

const CardAuthor = styled.h3`
  color: #fff;
  align-self: center;
`;

const CardDate = styled.p`
  font-size: 15px;
  color: #c0c0c0;
  align-self: center;
`;

const Dot = styled.div`
  width: 5px;
  height: 5px;
  border-radius: 2px;
  align-self: center;
  background-color: #c0c0c0;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    align-self: center;
  }
`;

const TagContainer = styled.div`
  width: 40vw;
  flex: 1;
  display: flex;
  flex-direction: row;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 70vw;
    margin-top: 15px;
  }
`;

const Tags = styled.p`
  font-size: 14px;
  width: 6vw;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  height: 30px;
  align-self: center;
  color: #fff;
  border-radius: 15px;
  background-color: #3700b3;

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: auto;
    padding: 5px 15px 5px 15px;
  }
`;

const BodyContent = styled.div`
  width: 30vw;
  height: auto;
  margin: auto;
  margin-top: 5px;

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 95vw;
    border: 0px solid #fff;
  }
`;

const Title = styled.h3`
  color: #fff;
`

const Body = styled.p`
  font-size: 16px;
  color: #fff;
  margin-top: 10px;
  a{
    color: hsl(320 100% 60%);
    text-decoration: none;
  }
`;

const PostImage = styled.img`
  width: 30vw;
  height: 35vh;
  object-fit: fill;
  border-radius: 15px;
  margin: 25px 0px 0px 0px;

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 95vw;
    height: 30vh;
    margin: 25px auto;
    border-radius: 10px;
    aspect-ratio: 16.9;
  }
`;

const NavButtonCaption = styled.a`
  color: hsl(320 100% 60%);
`;

const Impressions = styled.div`
  width: 30vw;
  flex: 1;
  display: flex;
  flex-direction: row;
  position: relative;
  margin: 15px auto;
  bottom: 0;

  img {
    width: 20px;
    height: 20px;
    align-self: center;
  }
  
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 95vw;
    flex: 1;
    margin: 0px auto;
    bottom: 5px;
  }
  

`

const ImpresionCaption = styled.p`
  font-size: 18px;
  color: #fff;
  align-self: center;
  margin-left: 10px;
`

export {
  Tags,
  Title,
  Body,
  BodyContent,
  NavButtonCaption,
  PostImage,
  TitleBar,
  ImpresionCaption,
  Impressions,
  ProfileImage,
  CardDate,
  CardAuthor,
  TagContainer,
  CardAuthorDetails,
  FeedCardContainer,
  TopContainer,
  PinnedContainer,
  PinnedContent,
  CardTitleInfo,
  Dot,
};
